import React, { FC } from 'react';
import { Chip, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { useStyles } from './TournamentSponsoredIndicator.styles';
import RedeemIcon from '@mui/icons-material/Redeem';

interface ComponentProps {
  withSmallIcon?: boolean;
}

export const TournamentSponsoredIndicator: FC<ComponentProps> = ({ withSmallIcon = false }) => {
  const { classes } = useStyles({ withSmallIcon });

  const theme = useTheme();
  const isLessThanXxs = useMediaQuery(theme.breakpoints.down('x-xs'));

  if (isLessThanXxs && withSmallIcon) {
    return (
      <Tooltip title="Reward Eligible" enterTouchDelay={0}>
        <Chip className={classes.root} icon={<RedeemIcon />} />
      </Tooltip>
    );
  }

  return <Chip className={classes.root} icon={<RedeemIcon />} label="Reward Eligible" />;
};
